<template>
  <Teleport to="body">
    <div
      v-if="currentSlide >= 0"
      class="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/95 px-3 py-16 backdrop-blur-sm md:px-10"
      role="dialog"
      aria-modal="true"
      aria-label="Otel fotoğraf galerisi"
      @click.self="close"
    >
      <div class="absolute left-4 top-4 rounded-full bg-white/10 px-3 py-1.5 text-xs font-bold text-white/80 backdrop-blur md:left-6 md:top-6">
        {{ currentSlide + 1 }} / {{ images.length }}
      </div>

      <button type="button" class="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition hover:bg-white/20 md:right-6 md:top-6" aria-label="Galeriyi kapat" @click="close">
        <font-awesome-icon icon="fa-solid fa-times" class="h-5 w-5" />
      </button>

      <button type="button" class="absolute left-3 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-black/35 text-white shadow-lg backdrop-blur transition hover:bg-white/20 md:left-6 md:h-12 md:w-12" aria-label="Önceki fotoğraf" @click="prev">
        <font-awesome-icon icon="fa-solid fa-chevron-left" class="h-5 w-5" />
      </button>

      <div class="relative z-10 flex h-full w-full max-w-7xl items-center justify-center" @click.self="close">
        <template v-for="(slide, index) in images" :key="slide.i || slide.video || index">
          <div v-if="currentSlide === index" class="flex h-full w-full flex-col items-center justify-center">
            <div v-if="slide.video" class="aspect-video w-full max-w-5xl overflow-hidden rounded-2xl bg-black shadow-2xl">
              <iframe :src="slide.video" title="Otel tanıtım videosu" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen class="h-full w-full"></iframe>
            </div>
            <img v-else :src="showImage(slide.i, 1800, 1200, true, 92)" :alt="slide.name || `Otel fotoğrafı ${index + 1}`" class="max-h-full max-w-full rounded-xl object-contain shadow-2xl" />
            <p v-if="slide.name" class="mt-3 max-w-2xl text-center text-sm font-medium text-white/75">{{ slide.name }}</p>
          </div>
        </template>
      </div>

      <button type="button" class="absolute right-3 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-black/35 text-white shadow-lg backdrop-blur transition hover:bg-white/20 md:right-6 md:h-12 md:w-12" aria-label="Sonraki fotoğraf" @click="next">
        <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-5 w-5" />
      </button>
    </div>
  </Teleport>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted } from 'vue'

const { showImage } = useCommon()
const emit = defineEmits(['close', 'setIndex'])
const props = defineProps({
  images: { type: Array, required: true },
  selectedIndex: { type: Number, required: true }
})

const currentSlide = computed(() => props.selectedIndex)
const close = () => emit('close')
const next = () => emit('setIndex', (currentSlide.value + 1) % props.images.length)
const prev = () => emit('setIndex', (currentSlide.value - 1 + props.images.length) % props.images.length)
const onKeydown = (event) => {
  if (event.key === 'Escape') close()
  if (event.key === 'ArrowRight') next()
  if (event.key === 'ArrowLeft') prev()
}

onMounted(() => window.addEventListener('keydown', onKeydown))
onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown))
</script>
